/** Статуси рядка просканованої позиції (incoming_shipment_scanned_items.scan_status). */

export const SCANNED_ITEM_STATUS_LABELS = {
  not_in_catalog: 'Не в каталозі',
  in_catalog: 'В каталозі',
  linked: 'Привʼязано'
};

export function scannedItemStatusLabel(status) {
  if (!status) return '—';
  return SCANNED_ITEM_STATUS_LABELS[status] || status;
}

export function scannedItemStatusBadgeClass(status) {
  if (!status) return 'badge badge-light text-muted';
  if (status === 'linked') return 'badge badge-success';
  if (status === 'in_catalog') return 'badge badge-primary';
  if (status === 'not_in_catalog') return 'badge badge-secondary';
  return 'badge badge-light';
}
